export default "__VITE_ASSET__3SzJkV9U__"